import { SHOW_MODAL, HIDE_MODAL } from "../Constants";

/* --- REDUCERS --- */
const initialState = {
    modalProps: {},
    template:''
}

export default (state = initialState, action) => {
    switch (action.type) {
        case SHOW_MODAL:
            return {
                modalProps : action.modalProps,
                template : action.template,
            };
        case HIDE_MODAL:
            return initialState;
        default:
            return state;
    }
};
